import { throttle } from 'lodash-es';
import { getOnlineSalePricing } from 'src/scripts/utils/helpers';

export const throttledHandleSlider = throttle((carousel: React.MutableRefObject<HTMLElement | null>) => {
  handleSlider(carousel);
}, 150);

export const handleSlider = (carousel: React.MutableRefObject<HTMLElement | null>) => {
  if (!carousel?.current) return;
  const section: HTMLElement | null = carousel.current.querySelector(`.crosssell-product--pdp`);

  const arrowRight: HTMLElement | null = carousel.current.querySelector(
    `.crosssell-product-container > .insta-arrow--right`
  );

  const arrowLeft: HTMLElement | null = carousel.current.querySelector(
    `.crosssell-product-container > .insta-arrow.left`
  );
  const items: HTMLElement[] = [...carousel.current.querySelectorAll(`.crosssell-product`)];

  const measures = items.map((item) => item.getBoundingClientRect().width);
  const rowWidth: number = measures.length > 0 ? measures.reduce((a, b) => a + b) : 0; // Get the real row width depending on the counts of the posts
  const sectionScrollPositionFromLeft = section ? section.scrollLeft : 0; // Section's horizontal scroll position from left
  const coordX: number = 5; // Define the scroll X-coordinate in px where arrows appear/hide
  const endOfSection: number = section ? rowWidth - section.getBoundingClientRect().width - 20 : 0;

  if (sectionScrollPositionFromLeft > coordX && arrowLeft) {
    arrowLeft.style.display = 'block';
  } else if (sectionScrollPositionFromLeft <= coordX && arrowLeft && arrowRight) {
    arrowLeft.style.display = 'none';
    arrowRight.style.display = 'block';
  }

  if (sectionScrollPositionFromLeft >= endOfSection && arrowRight) {
    arrowRight.style.display = 'none';
  } else if (arrowRight) {
    arrowRight.style.display = 'block';
  }
};

export const scrollOneScreen = (direction: string, ref: React.MutableRefObject<HTMLElement | null>) => {
  ref?.current?.scrollBy({
    left:
      direction === 'right' ? ref.current.getBoundingClientRect().width : -ref.current.getBoundingClientRect().width,
    behavior: 'smooth',
  });
};

export const getProductPrices = (
  tags: string[] | undefined,
  productPrice: number,
  productCompareAtPrice: number
): [number, number | null] => {
  const onlineSalePrice = tags ? getOnlineSalePricing(tags, productPrice) : undefined;
  const price = onlineSalePrice ? onlineSalePrice : productPrice;
  const compareAtPrice = onlineSalePrice ? productPrice : productCompareAtPrice ? productCompareAtPrice : null;
  return [price, compareAtPrice];
};
